import React from 'react'
import ErrorBoundary from './ErrorBoundary'

export default Component => props => (
  <ErrorBoundary>
    <Component {...props} />
  </ErrorBoundary>
)
